const VELOCITY = 5;
const VELOCITY_ADJUST = 20;

export const calculateVelocity = (a: number, b: number, incremental: boolean): number =>
    incremental ? (a += Math.floor((b - a) / VELOCITY)) + 1 : a > 0 ? (a = (a -= Math.floor(a / VELOCITY)) - 1) : 0;

export const calculateAdjustVelocity = (a: number, b: number, incremental: boolean): number => {
    const velocity = Math.floor(b / VELOCITY_ADJUST);
    const duration = b / velocity;

    if (incremental) {
        return (a += duration);
    } else {
        return (a -= duration);
    }
};
